<div class="w-full profile-container" *ngIf="!initialLoading">
    <p-toast />
    <p-confirmDialog #cd [style]="{'max-width': '60vw', 'width': '60vw'}" styleClass="custom-confirm-dialog">
        <ng-template pTemplate="headless" let-message>
            <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
                <div class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg animate-bounce-in">
                    <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
                </div>
                <div class="mt-16 text-center w-full">
                    <h3 class="text-2xl font-bold text-gray-900 mb-3">
                        {{ message.header }}
                    </h3>
                    <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
                        {{ message.message }}
                    </p>
                    <div class="flex items-center justify-center gap-3 mt-6">
                        <button 
                            pButton 
                            type="button"
                            [label]="message.acceptLabel || 'Yes, Continue'" 
                            (click)="message.accept && message.accept()" 
                            class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:-translate-y-0.5">
                        </button>
                        <button 
                            *ngIf="message.rejectVisible !== false"
                            pButton
                            type="button"
                            [label]="message.rejectLabel || 'Cancel'"
                            (click)="message.reject && message.reject()"
                            class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-confirmDialog>
    
    <div class="flex  flex-nowrap w-full p-3 gap-3 ">
        <div class="h-full relative">
            <p-card header="" class="flex h-[89vh]">
                <div class="flex space-x-2">
                    <!-- <img class="avatar-url" src="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
                    size="large" /> -->
                    <div style="display: flex; align-items: center;">
                        <p-avatar class="mr-2" size="xlarge" shape="circle"
                            [image]="previewImage || leadDetails.profile_pic"
                            *ngIf="leadDetails.profile_pic || previewImage; else showInitials" [style]="{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            cursor: 'pointer'
                          }" (click)="uploadInput.click()"></p-avatar>

                        <ng-template #showInitials>
                            <p-avatar class="mr-2" size="xlarge" shape="circle" label="{{ getInitials() }}" [style]="{
                              width: '60px',
                              height: '60px',
                              borderRadius: '50%',
                              fontSize: '30px',
                              cursor: 'pointer'
                            }" (click)="uploadInput.click()"></p-avatar>
                        </ng-template>

                        <input #uploadInput type="file" accept="image/*" (change)="onProfileImageUpload($event)"
                            style="display: none;" />
                    </div>



                    <div class="flex flex-col gap-3 justify-center">
                        <div class="flex flex-col gap-1">
                            <div class="text-[20px] font-bold ">
                                {{
                                getFullName()
                                }}
                            </div>
                            <div class="text-[12px]" *ngIf="editType == 'leads'">Lead ID: {{leadDetails.lead_id}}</div>
                            <div class="text-[11px]" *ngIf="editType == 'registration'">Registration ID: {{
                                leadDetails.registration.registration_id }}</div>
                            <div class="text-[11px]" *ngIf="editType == 'application'">Application No: {{
                                leadDetails.application_data.application_number }}</div>
                            <div class="text-[11px]" *ngIf="editType == 'enrollment'">Enrollment No: {{
                                leadDetails.enrollment_data.enrollment_number }}
                            </div>
                            </div>

                    </div>
                </div>

                <div class="flex items-center gap-2 mt-4 ml-2 max-w-[300px]">
                    <div class="text-[13px] break-all">
                        {{ leadDetails.email }}
                    </div>
                    <div>
                        <i class="pi pi-clone cursor-pointer" (click)="handleCopy()"></i>
                    </div>
                </div>


                <div class="mt-5 flex gap-3">
                    <!-- note email task meeting call -->
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenNoteDialog()">
                            <i class="pi pi-clipboard"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenNoteDialog()">
                            Notes
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2" *ngIf="accessObject.isEmailAccess">
                        <div class="action-icon" (click)="handleOpenEmailLead()">
                            <i class="pi pi-envelope"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenEmailLead()">
                            Email
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenTaskDialog()">
                            <i class="pi pi-list-check"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenTaskDialog()">
                            Task
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2" *ngIf="accessObject.isMeetingAccess">
                        <div class="action-icon" (click)="handleOpenMeetingDialog()">
                            <i class="pi pi-calendar"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenMeetingDialog()">
                            Meeting
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2" *ngIf="accessObject.isCallAccess">
                        <div class="action-icon" (click)="handleOpenCallLead()">
                            <i class="pi pi-phone"></i>
                        </div>
                        <div class="text-[13px] cursor-pointer" (click)="handleOpenCallLead()">
                            Call
                        </div>
                    </div>
                    <!-- <div class="flex flex-col items-center action-box gap-2">
                    <div class="action-icon">
                        <i class="pi pi-ellipsis-h"></i>
                    </div>
                    <div class="text-[13px]">
                        More
                    </div>
                </div> -->
                </div>

                <p-divider class="mt-2" class="divider"></p-divider>

                <h3 class="text-[20px] -mt-1 font-semibold">Quick Actions</h3>

                <div class="-mt-3 flex flex-col gap-2" *ngIf="editType == 'leads'">
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select [options]="users" [(ngModel)]="selectedOwner" placeholder="Select Assigned To"
                            class="w-full rounded-sm profile-select" 
                            appendTo="body"
                            />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Lead PipeLine</div>
                        <p-select [options]="pipelineStages" [(ngModel)]="selectedPipelineId"
                            optionLabel="label" optionValue="value"
                            (onChange)="onPipelineChange($event)"
                            appendTo="body"
                            placeholder="Select Lead Pipeline" class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Lead Status</div>
                        <p-select [options]="leadStatusList" [(ngModel)]="selectedStatus"
                            optionLabel="stage_name" optionValue="stage_name"
                            (onChange)="onStatusChange($event)"
                            appendTo="body"
                            placeholder="Select Lead Status" class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Lead Score</div>
                        <input pInputText [(ngModel)]="selectedPipelineScore" 
                            [disabled]="true"
                            placeholder="Score will be auto-filled"
                            class="w-full rounded-sm" 
                            style="opacity: 0.6; cursor: not-allowed;" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Lead Type</div>
                        <p-select [options]="leadTypes" [(ngModel)]="selectedType" placeholder="Select Lead Type"
                        appendTo="body"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Query Type</div>
                        <p-select [options]="queryTypes" [(ngModel)]="selectedQueryType" placeholder="Select Query Type"
                            class="w-full rounded-sm profile-select" appendTo="body" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Lead Source</div>
                        <p-select [options]="leadSources" [(ngModel)]="selectedSource" placeholder="Select Source"
                            class="w-full rounded-sm profile-select" appendTo="body" />
                    </div>
                </div>

                <div class="-mt-3 flex flex-col gap-2" *ngIf="editType == 'registration' || editType == 'application'">
                    <div class="mt-2" *ngIf="editType == 'registration'">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select appendTo="body" [options]="users" [(ngModel)]="selectedOwner" placeholder="Select Assigned To"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2" *ngIf="editType == 'application'">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select [options]="users" [(ngModel)]="applicationOwner" placeholder="Select Assigned To"
                            class="w-full rounded-sm profile-select"
                            appendTo="body"
                            />
                    </div>

                    <div class="mt-2" *ngIf="editType == 'registration'">
                        <div class="mb-2 font-medium">Registration Status</div>
                        <p-select appendTo="body" [options]="registrationStatusList" [(ngModel)]="selectedRegistrationStatus"
                            placeholder="Select Registration Status" class="w-full rounded-sm profile-select"
                              appendTo="body"
                            />
                    </div>

                    <div class="mt-2" *ngIf="editType == 'application'">
                        <div class="mb-2 font-medium">Application Status</div>
                        <p-select [options]="applicationStatusList" [(ngModel)]="selectedApplicationStatus"
                            placeholder="Select Lead Status" class="w-full rounded-sm profile-select" 
                              appendTo="body"
                            />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Source</div>
                        <p-select [options]="leadSources" [(ngModel)]="selectedSource" placeholder="Select Source"
                            class="w-full rounded-sm profile-select" appendTo="body" />
                    </div>
                </div>

                <div class="-mt-3 flex flex-col gap-2" *ngIf="editType == 'enrollment'">
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Assigned To</div>
                        <p-select [options]="users" [(ngModel)]="selectedOwner" placeholder="Select Assigned To"
                            class="w-full rounded-sm profile-select" 
                              appendTo="body"
                            />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Enrollment Status</div>
                        <p-select appendTo="body" [options]="enrollmentStatusList"
                            [(ngModel)]="selectedEnrollmentStatus" placeholder="Select Lead Status"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2">
                        <div class="mb-2 font-medium">Source</div>
                        <p-select appendTo="body" [options]="leadSources" [(ngModel)]="selectedSource"
                            placeholder="Select Source" class="w-full rounded-sm profile-select" />
                    </div>
                </div>

                <div class="mb-12">

                </div>

                <div class="mt-8 flex items-center gap-2 absolute  bottom-buttons">
                    <p-button label="Back" icon="pi pi-arrow-left" (onClick)="handleBack()" severity="secondary" />
                    <p-button label="Save" class="w-full" [loading]="loading" (onClick)="handleSaveQuickActions()"
                        [disabled]="loading" />

                </div>

            </p-card>
        </div>

        <div class="w-full">
            <p-card class="flex h-[89vh]">
                <app-lead-profile-middle-screen [selectedTabIdx]="selectedTabIdx" [users]="users" [editType]="editType"
                    [allCourses]="allCourses"
                    [fullUserList]="fullUserList"
                    [paymentForList]="paymentForList"
                    [fullCourseList]="fullCourseList"
                    [allLeadFeilds]="allLeadFeilds" [editLeadData]="leadDetails"
                    (handleUpdateData)="updateData($event)"
                    (changeTab)="handleTabChange($event)"></app-lead-profile-middle-screen>
            </p-card>
        </div>

        <div class="min-w-[350px] w-full">
            <p-card class="flex h-[89vh] min-w-[350px] w-full">
                <div *ngIf="selectedTabIdx == 0" class="w-full">
                    <app-lead-timeline [timelineData]="leadActivity"></app-lead-timeline>
                </div>
                <div *ngIf="selectedTabIdx == 1">
                    <app-lead-followup-form></app-lead-followup-form>
                </div>
            </p-card>
        </div>
    </div>
</div>

<div *ngIf="initialLoading" class="h-[80vh] flex items-center justify-center w-screen">
    <p-progress-spinner ariaLabel="loading" [style]="{ width: '100px', height: '100px' }" strokeWidth="2" />
</div>


@defer (when isAddNote) {
<p-dialog [modal]="true" [(visible)]="isAddNote" [breakpoints]="{ '1199px': '55vw', '575px': '90vw' }" closable="false"
    [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-add-note 
    [lead_id]="lead_id"
    (closeDialog)="handleCloseNoteDialog()"></app-add-note>
</p-dialog>
}

@defer (when isEmailLead) {
<p-dialog [modal]="true" [(visible)]="isEmailLead" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-lead-email (closeDialog)="handleCloseEmailDialog()" [communicationData]="leadDetails"></app-lead-email>
</p-dialog>
}

@defer (when isAddTask) {
<p-dialog [modal]="true" [(visible)]="isAddTask" [breakpoints]="{ '1199px': '55vw', '575px': '90vw' }" closable="false"
    [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-lead-task (closeDialog)="handleCloseTaskDialog()"></app-lead-task>
</p-dialog>
}

@defer (when isAddMeeting) {
<p-dialog [modal]="true" [(visible)]="isAddMeeting" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-lead-meeting [leadDetails]="leadDetails" (closeDialog)="handleCloseMeetingDialog()"></app-lead-meeting>
</p-dialog>
}

@defer (when isCallLead) {
<p-dialog [modal]="true" [(visible)]="isCallLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
    closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
    <app-lead-call (closeDialog)="handleCloseCallDialog()" [communicationData]="leadDetails"></app-lead-call>
</p-dialog>
}